import { render, staticRenderFns } from "./ListImportPage.vue?vue&type=template&id=fa15da10"
import script from "./ListImportPage.vue?vue&type=script&lang=js"
export * from "./ListImportPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports